import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faCalendarMinus,
  faCalendarPlus,
  faCalendarTimes,
  faUserGroup,
} from '@fortawesome/free-solid-svg-icons';
import { Session } from '@univacity/shared/types';

@Component({
  selector: 'un-tour-session',
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './tour-session.component.html',
  styleUrls: ['./tour-session.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourSessionComponent {
  @Input() session: Session;
  faCalendar = faCalendarPlus;
  faCalendarMinus = faCalendarMinus;
  faCalendarTimes = faCalendarTimes;
  faUserGroup = faUserGroup;
}
